import * as React from 'react';
import * as ReactDOM from 'react-dom/client';

const Pages = props => {
  return (
    <div className="pages-tab-content">
      <div className="flex-row wid1200">
        <img className="item-pic" src ='/images/about/contact.jpg'/>
        <div className="item-body ml64 lh">
          <div className="mb-default">联系电话：0755-86199719</div>
          <div className="mb-default">电子邮箱：mingxinsk@mingxinsk.com</div>
          <div className="mb-default">联系地址：深圳市南山区粤海街道深圳湾科技生态园12栋B座50楼</div>
        </div>
      </div>
    </div>
  )
}
export default Pages